import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-booking-challenge-form',
  templateUrl: './booking-challenge-form.component.html',
  styleUrls: ['./booking-challenge-form.component.scss']
})
export class BookingChallengeFormComponent {
  @Input() bookingChallengeForm!: FormGroup;
  @Input() allUsers: any[] = [];
  @Input() challengeParticipantFlag: boolean = false;
  @Input() bookingWinnersOptions: any[] = [];
  @Input() totalCompanyCreditsAvailable: any;
  @Input() bookingTicketError: string = '';
  @Input() errMessages: any = {};
  @Input() minDate: any;
  @Input() minEndDate: any;
  @Input() maxDate: any;
  @Input() updateFlag: boolean = false;

  @Output() ticketCalculation = new EventEmitter<void>();
  @Output() startDateChange = new EventEmitter<any>();
  @Output() resetForm = new EventEmitter<void>();
  @Output() postForm = new EventEmitter<boolean>();

  isEmptyUser(): boolean {
    if (!this.bookingChallengeForm) { return true; }
    const users = this.bookingChallengeForm.get('users');
    return !users || !users.value || users.value.length === 0;
  }
}
